"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureFlagsProvider = FeatureFlagsProvider;

var _react = _interopRequireWildcard(require("react"));

var _launchdarklyReactClientSdk = require("launchdarkly-react-client-sdk");

var _store = require("../../redux/store");

var _selectors = require("./selectors");

var _user = require("../../redux/selectors/user");

function FeatureFlagsProvider({
  children
}) {
  const context = (0, _store.useAppSelector)(_selectors.launchDarklyUserSelector);
  const optOutUserTracking = (0, _store.useAppSelector)(_user.selectUserTrackingState);
  const WithLDProvider = (0, _react.useMemo)(() => {
    const clientSideID = window.LAUNCH_DARKLY_CLIENT_SIDE_ID;
    if (!clientSideID) return undefined; // Ensure context and settings are defined before returning the provider.
    // This prevents double initialisation.

    if (!context) return undefined;
    return (0, _launchdarklyReactClientSdk.withLDProvider)({
      clientSideID,
      deferInitialization: false,
      reactOptions: {
        useCamelCaseFlagKeys: false
      },
      options: {
        allAttributesPrivate: true
      },
      context
    })(p => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, p.children));
  }, [context, optOutUserTracking]); // Don't render anything if the LD provider isn't ready

  if (WithLDProvider == null) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
  return /*#__PURE__*/_react.default.createElement(WithLDProvider, null, children);
}